class FilterValueSearch extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => this.initialize());
  }

  initialize() {
    if (this.input) return;
    this.input = this.querySelector('input[type="search"]');
    this.emptyMessage = this.querySelector('[data-filter-search-empty]');
    this.list = document.getElementById(this.getAttribute('for'));
    if (!this.input || !this.list) return;

    this.items = [...this.list.querySelectorAll('[data-filter-value]')];
    this.showMoreButton = this.list.closest('show-more-component')?.querySelector('[ref="showMoreButton"]');

    for (const item of this.items) {
      item.dataset.filterInitiallyHidden = String(item.classList.contains('hidden'));
      item.dataset.filterInitiallyMobileHidden = String(item.classList.contains('mobile:hidden'));
    }

    this.input.addEventListener('input', this.handleInput);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.handleInput);
  }

  handleInput = () => {
    const query = this.input.value.trim().toLocaleLowerCase();
    let matches = 0;

    for (const item of this.items) {
      const isMatch = !query || item.dataset.filterValue.toLocaleLowerCase().includes(query);
      item.classList.toggle('filter-value-search__item--hidden', !isMatch);

      if (query && isMatch) {
        item.classList.remove('hidden', 'mobile:hidden');
      } else if (!query) {
        item.classList.toggle('hidden', item.dataset.filterInitiallyHidden === 'true');
        item.classList.toggle('mobile:hidden', item.dataset.filterInitiallyMobileHidden === 'true');
      }

      if (isMatch) matches += 1;
    }

    if (this.emptyMessage) this.emptyMessage.hidden = matches > 0;
    if (this.showMoreButton) this.showMoreButton.hidden = Boolean(query);
  };
}

if (!customElements.get('filter-value-search')) {
  customElements.define('filter-value-search', FilterValueSearch);
}
